// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { ContactPerson } from "#/modules/common/organization_chart_module/contact_person/ContactPerson";

// Services
import { Api } from "#/api";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ContactPerson,
  },
})
export class OrganizationChartModule extends ModuleBase {
  public persons: Object = {};

  public async getPerson(personFields) {
    try {
      let personId = personFields["person_id"];
      if (this.persons.hasOwnProperty(personId)) {
        let p = this.persons[personId];
        return p.hasOwnProperty("rq_status") && p["rq_status"] === "pending"
          ? null
          : p;
      }

      this.persons[personId] = Object.assign({}, personFields, {
        rq_status: "pending",
      });

      let person = await Api.personService.getPerson([personId]);

      let o = Object.assign({}, this.persons);

      o[personId] = Object.assign({}, o[personId], person[0], {
        rq_status: "done",
      });
      this.persons = o;
      return this.persons[personId];
    } catch (ex) {
      return false;
    }
  }

  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }
}
